import { createSlice } from '@reduxjs/toolkit'
import { RootState } from "../../store";


export interface PasswordState {
    value: string
}

const initialState: PasswordState = {
    value: ''
}

export const passwordSlice = createSlice({
    name: 'password',
    initialState,
    reducers: {
        savePassword: (state, action) => {
            state.value = action.payload
        }
    }
})

export const { savePassword } = passwordSlice.actions;

export const passwordStoreValue = (state: RootState) => state.password.value;

export default passwordSlice.reducer
